/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/pulzar/"

const pulzar: CommunityData = {
  code: "pulzar",
  inviteCode: "pulzar",
  name: "PULZAR",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/pul-030`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#1325ec",
      hero: {
        desktop: `${S3_PREFIX}web-background.png`,
        mobile: `${S3_PREFIX}web-background-mobile.png`,
        style: "bg-[#1325ec]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[130px] invert",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['MonumentExtendedRegular'] text-[28px] leading-[120%] uppercase text-[#ffffff]",
      text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] leading-[120%] p-4 rounded-[8px] bg-[#c2fe00] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] w-[256px] rounded-[8px] px-4 h-[48px] bg-[#0e1bb8] text-[#ffffff]",
        border: "#3344ee",
        borderFocus: "#c2fe00",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#ffffff80]",
      skipButton:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#ffffff80] cursor-pointer",
      modal: {
        container: "bg-[#0e1bb8] px-[40px] py-[48px]",
        title:
          "font-['MonumentExtendedRegular'] text-[24px] leading-[120%] uppercase text-[#ffffff] text-center",
        text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#ffffff80] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#1325ec] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        otpBorder: "#3344ee",
        otpBorderFocus: "#c2fe00",
      },
    },
    global: {
      counterColor: "#c2fe00",
      logo: {
        src: "https://media.werz.at/community/icon/cmgs0erlh00019k1c4cm4269g.jpg?uploadTime=1776279015419&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[188px] h-[18px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#1325ec",
      asideBg: "#c2fe00",
      asideStyles: "border-r border-[#c2fe00]",
      contentBg: "#1325ec",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#c2fe00] border border-[#c2fe00] rounded-[8px] px-[18px] py-[18px] !text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#ffffff33]",
      item: "font-['AkiraExpandedSuperBold'] text-[14px] text-[#000000] text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#ffffff33] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#1325ec] !pb-8",
      titles:
        "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff40]",
        sectionTitle:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['MonumentExtendedRegular'] text-[12px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff40]",
        sectionTitle:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['MonumentExtendedRegular'] text-[12px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[18px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/pulzar/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/pulzar/web-background-non-member.png",
      bgColor: "#1325ec",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#1325ec]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#1325ec]",
        name: "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-center text-center mt-4 mb-1",
        location:
          "font-['MonumentExtendedRegular'] uppercase text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#c2fe00",
        button:
          "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#1325ec] border border-[#1325ec] text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#1325ec] border border-[#1325ec]",
          title:
            "font-['MonumentExtendedRegular'] uppercase text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#1325ec] border border-[#1325ec]",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#c2fe00",
          media: "overflow-hidden m-2 border border-[#1325ec]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#1325ec] border border-[#1325ec]",
          name: "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#c2fe00] border border-[#c2fe00] rounded-[8px] text-[#000000] font-['MonumentExtendedRegular'] text-[12px] uppercase text-center",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#1325ec]",
            name: "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[14px] text-left",
            link: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] leading-[18px] text-left",
            status:
              "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase leading-[100%] text-[14px] text-left",
            button:
              "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#1325ec] border border-[#1325ec] text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#1325ec] border border-[#1325ec]",
          name: "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#c2fe00",
          created:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#1325ec]",
        },
        seeAllNews:
          "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#1325ec] border border-[#1325ec] text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#1325ec] border border-[#1325ec]",
          coverUrl: "overflow-hidden m-2 border border-[#1325ec]",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#1325ec",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#1325ec",
          start:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#1325ec] border border-[#1325ec] text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#1325ec] border border-[#1325ec]",
          name: "text-[#ffffff] font-['MonumentExtendedRegular'] uppercase text-[16px] text-left",
          triangleIconColor: "#c2fe00",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#1325ec]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#1325ec] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ffffff40]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#c2fe00] border border-[#c2fe00] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['NeueHaasGroteskDisplayPro65Medium'] !text-[16px] text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff40]",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[18px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff40]",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[18px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#1325ec00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[18px] uppercase text-left leading-[100%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['MonumentExtendedRegular'] text-[22px] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#1325ec] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#1325ec] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['MonumentExtendedRegular'] text-[12px] uppercase text-left leading-[100%] mb-1",
          description:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['MonumentExtendedRegular'] text-[12px] uppercase text-left leading-[100%]",
          quantity:
            "text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['MonumentExtendedRegular'] text-[12px] uppercase text-left leading-[100%]",
          counterContainer:
            "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#1325ec] border border-[#c2fe00] rounded-[8px] px-[12px] py-[12px] text-[#c2fe00] font-['NeueHaasGroteskDisplayPro65Medium'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#c2fe00",
        },
      },
    },
  },
}

export default pulzar
